/** 상대 경로 요청 앞에 API 베이스 URL을 붙인다. */
export function baseUrlLayer(baseUrl) {
    return (next) => (path, init) => next(`${baseUrl}${path}`, init);
}
//# sourceMappingURL=baseUrlLayer.js.map